import React, { Component } from "react";
import { Form, Button, Select } from "antd";
import styles from "./listSearch.less";

const { Item } = Form;
const { Option } = Select;

@Form.create()
class ListSearch extends Component {
  onSubmit = e => {
    e.preventDefault();
    const { form, onSearch } = this.props;
    const { validateFields } = form;
    validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }
      onSearch(fieldsValue)
    });
  }

  onReset = () => {
    const { form, handleReset } = this.props;
    const { resetFields } = form;
    resetFields();
    if (handleReset) {
      handleReset();
    }
  };


  render() {
    const { form, statusList = [] } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form className={styles.listSearch} onSubmit={this.onSubmit}>
        <Item label="查询条件">
          {getFieldDecorator(`status`, {
            initialValue: statusList[0] && statusList[0].id
          })(
            <Select placeholder="请选择">
              {
                statusList.map(item => (
                  <Option value={item.id}>{item.name}</Option>
                ))}
            </Select>
          )}
        </Item>
        <div>
          <Button type="primary" htmlType="submit">
            查询
        </Button>
          <Button style={{ marginLeft: 8 }} onClick={this.onReset}>
            重置
        </Button>
        </div>
      </Form>
    );
  }
}

export default ListSearch;
